import React from 'react'

// A name or breadcrumb with its matched characters marked: consecutive
// matched indices are one <mark>. React text and elements only -- never an
// HTML string: names are what people typed (spec §5.1).
export const runsOf = (text, indices) => {
  const runs = []
  if (!text) return runs
  const marked = new Set(indices || [])
  let start = 0
  for (let i = 1; i <= text.length; i++) {
    if (i === text.length || marked.has(i) !== marked.has(start)) {
      runs.push({ text: text.slice(start, i), hit: marked.has(start) })
      start = i
    }
  }
  return runs
}

export const SearchHighlight = ({ text, indices }) =>
  <React.Fragment>
    {runsOf(text, indices).map((run, i) =>
      run.hit
        ? <mark key={i} className="search-hit">
            {run.text}
          </mark>
        : <React.Fragment key={i}>
            {run.text}
          </React.Fragment>
    )}
  </React.Fragment>
